import { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import { AppProvider } from '@/lib/provider/AppProvider'
import { AuthProvider } from '@/lib/provider/AuthProvider'
import { queryClient } from '@/lib/queryClient'
import { ApiService } from '@/lib/services/ApiService'
import { TenantProvider } from '@/lib/provider/TenantProvider'
import { setupAxiosAuth } from '@/lib/auth/setupAxiosAuth'
import { initSentry, SentryIdentitySync } from '@/lib/sentry'

setupAxiosAuth()

import App from './App'
const apiService = new ApiService()

function SafeHydrate({ children }: any) {
  useEffect(() => {
    apiService.getSentrySettings().then(({ data }) => {
      if (!!data.environment && data.environment !== 'development') {
        initSentry(data.environment)
      }
    })
  }, [])

  return (
    <div className="h-full" suppressHydrationWarning>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </div>
  )
}

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)
root.render(
  <BrowserRouter>
    <SafeHydrate>
      <AppProvider>
        <AuthProvider>
          <TenantProvider>
            <SentryIdentitySync />
            <App />
          </TenantProvider>
        </AuthProvider>
      </AppProvider>
    </SafeHydrate>
  </BrowserRouter>
)
